import React, { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import cn from 'classnames';

import TransitionHandler from './TransitionHandler';
import css from './CardTransition.scss';

type Props = {
	data: { _id?: string };
	className?: string;
	children: React.ReactNode;
};
const CardTransition = (props: Props) => {
	const progressRef = useRef({
		// initially `in` animation is no complete
		in: 0,
		// initially `out` animation is complete, since there is nothing to animate
		out: 1,
	})!;

	return (
		<TransitionGroup className={cn(css.transition, props.className)} appear enter exit>
			<TransitionHandler key={props.data._id} progressRef={progressRef}>
				{props.children}
			</TransitionHandler>
		</TransitionGroup>
	);
};

export default CardTransition;

export { CardTransitionContext } from './TransitionHandler';
